import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // CookieYes selectors
  cookieYesSelectors = ['div[id^="cky-"]', 'div[class*="cky-"]'];

  connect() {
    // Move CookieYes elements immediately
    this.moveCookieYesToPermanentContainer();

    // Set up MutationObserver to automatically move CookieYes elements when they're added to DOM
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (this.isCookieYesElement(node)) {
            this.moveCookieYesToPermanentContainer();
          }
        });
      });
    });

    // Start observing the document body for CookieYes elements
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Listen to Turbo events
    ['turbo:load', 'turbo:render', 'turbo:before-cache'].forEach(eventName => {
      document.addEventListener(eventName, this.moveCookieYesToPermanentContainer.bind(this));
    });
  }

  disconnect() {
    // Clean up observer when controller is disconnected
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  moveCookieYesToPermanentContainer() {
    const container = document.getElementById('cookieyes-container');
    if (!container) return;

    this.cookieYesSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (!container.contains(element) && element.id !== 'cookieyes-container') {
          container.appendChild(element);
        }
      });
    });
  }

  isCookieYesElement(element) {
    if (element.nodeType !== Node.ELEMENT_NODE) return false;
    return this.cookieYesSelectors.some(selector => element.matches(selector));
  }
}

